import { For } from "solid-js";

interface Props {
  sectors: string[];
  search: string;
  sector: string;
  onSearch: (v: string) => void;
  onSector: (v: string) => void;
}

export default function Filters(p: Props) {
  return (
    <section class="controls">
      <input
        id="search-input"
        class="control control-search"
        type="search"
        placeholder="search firm, sector, hq... (press / to focus)"
        value={p.search}
        onInput={(e) => p.onSearch(e.currentTarget.value)}
      />
      <select
        class="control"
        value={p.sector}
        onChange={(e) => p.onSector(e.currentTarget.value)}
      >
        <option value="">all sectors</option>
        <For each={p.sectors}>
          {(s) => <option value={s}>{s.toLowerCase()}</option>}
        </For>
      </select>
    </section>
  );
}
